module.exports = __webpack_public_path__ + "img/px-player.734f0cd1.png";